// 'practice' namespace — keys are prefixed 'practice.'. Russian is the primary UI language.
const ru: Record<string, string> = {
  'practice.yourDrafts': 'Ваши черновики в этом режиме',
  'practice.noTasks': 'Для этого режима пока нет заданий',
  'practice.noTasksText': 'Когда в библиотеку добавят подходящие письма, они появятся здесь.',
  'practice.needsNetwork': 'Нужна сеть: сервер закрепляет версию образца перед началом.',
  'practice.needsNetworkShort': 'Копирование и воспроизведение требуют сети.',

  'practice.copy.title': 'Копирование',
  'practice.copy.subtitle': 'Выберите образец и перепишите его от руки — текст остаётся перед глазами всё время.',
  'practice.copy.referenceTitle': 'Текст для копирования',
  'practice.copy.noReference': 'У этого задания пока нет образцового текста, поэтому его нельзя переписать.',
  'practice.copy.start': 'Начать копирование',
  'practice.copy.startHint': 'Версия текста будет закреплена — изменения в библиотеке не повлияют на эту попытку.',

  'practice.recall.title': 'Воспроизведение',
  'practice.recall.subtitle': 'Изучите письмо, скройте его и напишите по памяти.',
  'practice.recall.howTitle': 'Как это работает',
  'practice.recall.step1': 'Читайте образец заданное время — или нажмите «Скрыть образец и писать», когда будете готовы.',
  'practice.recall.step2': 'Текст скрывается, и вы пишете письмо по памяти от руки.',
  'practice.recall.step3': 'Если застряли — лесенка подсказок: заголовок → начала абзацев → ключевые слова. Каждая подсказка записывается.',
  'practice.recall.step4': 'После отправки пропуски по памяти показываются отдельно от орфографических ошибок.',
  'practice.recall.textTitle': 'Текст',
  'practice.recall.textHidden': 'Текст появится только на этапе изучения, чтобы время шло честно.',
  'practice.recall.length': 'Длина образца: {words}.',
  'practice.recall.referenceWithheld': 'У вас уже идёт строгая попытка с этим текстом — образец скрыт до её отправки.',
  'practice.recall.choose': 'Начать воспроизведение',
  'practice.recall.dialogTitle': 'Воспроизведение по памяти',
  'practice.recall.studyTime': 'Время на изучение',
  'practice.recall.studyTimeHint': 'Скрыть текст можно и раньше. Выбор запоминается на этом устройстве.',
  'practice.recall.sec': '{n} с',
  'practice.recall.min': '{n} мин',
  'practice.recall.strict': 'Строгий режим',
  'practice.recall.strictHint':
    'После скрытия образец больше не загружается с сервера — даже при перезагрузке страницы. Подходит для честной самопроверки. В обычном режиме текст можно открыть снова: это учебное пособие, а не экзамен.',
  'practice.recall.start': 'Начать изучение',

  'practice.free.title': 'Свободное письмо',
  'practice.free.subtitle': 'Чистая страница тетради или задание из библиотеки. Черновик можно править сколько угодно до отправки.',
  'practice.free.blankHeading': 'Чистая страница',
  'practice.free.topicLabel': 'Тема на греческом',
  'practice.free.optional': 'необязательно',
  'practice.free.topicPlaceholder': 'Γράψε ένα email σε έναν φίλο για το Σαββατοκύριακο…',
  'practice.free.topicHint': 'Тема видна во время письма и помогает проверке понять контекст.',
  'practice.free.noPromptNote':
    'Без задания проверяются грамматика, орфография и стиль на уровне A2. Выполнение задания не оценивается — оценивать нечего.',
  'practice.free.withTopicNote':
    'Ваша тема — просто подсказка для себя и для проверки. Выполнение задания по ней не оценивается; для этого выберите задание из библиотеки ниже.',
  'practice.free.startBlank': 'Открыть чистую страницу',
  'practice.free.startWithTopic': 'Начать письмо на эту тему',
  'practice.free.blankTitle': 'Свободное письмо',
  'practice.free.offlineOk': 'Можно начать без сети — черновик синхронизируется позже.',
  'practice.free.libraryHeading': 'Или напишите по заданию',
  'practice.free.libraryText': 'Задание задаёт ситуацию, обязательные пункты и объём — по ним оценивается выполнение задания.',
  'practice.free.startTask': 'Писать по заданию',
};
const en: Record<string, string> = {
  'practice.yourDrafts': 'Your drafts in this mode',
  'practice.noTasks': 'No tasks for this mode yet',
  'practice.noTasksText': 'Suitable letters will appear here once they are added to the library.',
  'practice.needsNetwork': 'Needs a connection: the server pins the model-text version before you start.',
  'practice.needsNetworkShort': 'Copy and recall need a connection.',

  'practice.copy.title': 'Copy practice',
  'practice.copy.subtitle': 'Pick a model letter and copy it by hand — the text stays in view the whole time.',
  'practice.copy.referenceTitle': 'Text to copy',
  'practice.copy.noReference': 'This task has no model text yet, so it cannot be copied.',
  'practice.copy.start': 'Start copying',
  'practice.copy.startHint': 'The text version is pinned — later library edits will not affect this attempt.',

  'practice.recall.title': 'Recall practice',
  'practice.recall.subtitle': 'Study a letter, hide it and write it from memory.',
  'practice.recall.howTitle': 'How it works',
  'practice.recall.step1': 'Read the model for the set time — or press “Hide model and write” when you are ready.',
  'practice.recall.step2': 'The text is hidden and you write the letter from memory by hand.',
  'practice.recall.step3': 'Stuck? Use the hint ladder: title → paragraph starts → keywords. Every hint is recorded.',
  'practice.recall.step4': 'After submitting, recall omissions are shown separately from spelling errors.',
  'practice.recall.textTitle': 'Text',
  'practice.recall.textHidden': 'The text is shown only during the study phase, so the clock stays fair.',
  'practice.recall.length': 'Model length: {words}.',
  'practice.recall.referenceWithheld': 'You already have a strict attempt with this text in progress — the model stays hidden until you submit it.',
  'practice.recall.choose': 'Start recall',
  'practice.recall.dialogTitle': 'Recall from memory',
  'practice.recall.studyTime': 'Study time',
  'practice.recall.studyTimeHint': 'You can hide the text earlier. Your choice is remembered on this device.',
  'practice.recall.sec': '{n} s',
  'practice.recall.min': '{n} min',
  'practice.recall.strict': 'Strict mode',
  'practice.recall.strictHint':
    'Once hidden, the model text is not loaded from the server again — not even after a reload. Good for honest self-testing. In regular mode you can reopen the text: it is a study aid, not an exam.',
  'practice.recall.start': 'Start studying',

  'practice.free.title': 'Free writing',
  'practice.free.subtitle': 'A blank notebook page or a library prompt. Edit the draft as much as you like until you submit.',
  'practice.free.blankHeading': 'Blank page',
  'practice.free.topicLabel': 'Topic in Greek',
  'practice.free.optional': 'optional',
  'practice.free.topicPlaceholder': 'Γράψε ένα email σε έναν φίλο για το Σαββατοκύριακο…',
  'practice.free.topicHint': 'The topic stays visible while you write and gives the checker context.',
  'practice.free.noPromptNote':
    'Without a task, grammar, spelling and style are checked at A2 level. Task fulfilment is not scored — there is nothing to score it against.',
  'practice.free.withTopicNote':
    'Your topic is just a cue for you and the checker. Task fulfilment is not scored against it; pick a library task below for that.',
  'practice.free.startBlank': 'Open a blank page',
  'practice.free.startWithTopic': 'Start writing on this topic',
  'practice.free.blankTitle': 'Free writing',
  'practice.free.offlineOk': 'You can start offline — the draft syncs later.',
  'practice.free.libraryHeading': 'Or write to a task',
  'practice.free.libraryText': 'A task sets the situation, required points and length — task fulfilment is scored against them.',
  'practice.free.startTask': 'Write to this task',
};
export default { ru, en };
